import { render, staticRenderFns } from "./IronDate5.vue?vue&type=template&id=7f851f82&"
import script from "./IronDate5.vue?vue&type=script&lang=js&"
export * from "./IronDate5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports